module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_is-object.js
// module id = 10
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_is-object.js